import { GLOBAL_CONFIG } from "shared/constants/global.config";
import { ProjectConfig } from "shared/types/GlobalConfig";

export const checkIfDegods = () => {
    const { HYPERSPACE_PROJECT_ID } = GLOBAL_CONFIG as ProjectConfig;
    const isDegods = HYPERSPACE_PROJECT_ID === "degods"
    return isDegods;
}